<div class="img-container">
  <img [src]="imgUri" alt="Image Preview" />
</div>